<template>
  <div class="banner">
    <div class="container">
      <p v-html="summaryText" ref="bannerText" class="banner__text"></p>
      <div class="banner__wrapper-title" ref="bannerWrapperTitle">
        <h1
          class="banner__title"
          ref="bannerTitle"
          v-html="
            splitText(perYear(totalEconomy.money, true)) + ' <span>₽</span><span class=banner__year>в&nbsp;год</span>'
          "
        ></h1>
      </div>
      <div class="banner__wrapper-button" ref="bannerWrapperButton">
        <button type="button" class="button banner__button button--primary" data-modal="#demoRequestModal">
          Оставить заявку на&nbsp;демо
        </button>
        <div class="banner__links">
          <a href="/calc" class="banner__link">Рассчитать заново</a>
          <a href="#" data-modal="#calc-modal" class="banner__link">Как мы&nbsp;считаем</a>
        </div>
      </div>
    </div>
    <div class="banner__scroll-btn-wrapper" ref="bannerScrollBtnWrapper">
      <button
        class="banner__scroll-btn"
        :class="{ 'banner__scroll-btn--disabled': isScrollBtnHidden }"
        ref="scrollBtn"
        @click="scrollToSlider"
      >
        <span>
          Хантфлоу сэкономит вам много ресурсов
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8L14.25 19.25L25.5 8" stroke="#c6c6c6" stroke-width="4" />
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { scrollAnimationProgress } from '~scripts/core/animations';
import anime from 'animejs/lib/anime.es.js';
import scrollTo from '~scripts/core/scrollTo';
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { pluralize } from '~scripts/core/helpers';

function sum(...nums) {
  return nums.reduce((a, b) => +a + +b, 0);
}

const numFormat = new Intl.NumberFormat('ru-RU');

export default {
  name: 'CalculationResultBanner',
  props: {
    params: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isScrollBtnHidden: false,
    };
  },
  computed: {
    searchParams() {
      const urlObject = new URL(window.location.href);
      return urlObject.searchParams;
    },
    mediaSm() {
      return window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);
    },
    mediaMd() {
      return window.matchMedia(`(max-width: ${BREAKPOINTS.mdMax})`);
    },

    recruitersAmount() {
      return Math.max(0, this.searchParams.get('amount') || 0);
    },
    totalEconomy() {
      return {
        days: sum(this.value.resume.days, this.value.mail.days, this.value.cal.days, this.value.mail_tpl.days),
        money: sum(this.value.resume.money, this.value.mail.money, this.value.cal.money, this.value.mail_tpl.money),
      };
    },
    summaryText() {
      let timeSavingsText = `<span class="banner__text-days">${pluralize(this.perYear(this.totalEconomy.days), [
        'рабочий день',
        'рабочих дня',
        'рабочих дней',
      ])
        .split(' ')
        .join('&nbsp;')} в&nbsp;год</span> <br>`;
      if (this.recruitersAmount > 1) {
        timeSavingsText += ` <span>на ${pluralize(this.recruitersAmount, [
          'рекрутера.</span>',
          'рекрутеров.</span>',
          'рекрутеров.</span>',
        ])
          .split(' ')
          .join('&nbsp;')}`;
      } else {
        timeSavingsText += `<span> на&nbsp;рекрутера.</span>`;
      }

      return `<span>Хантфлоу высвобождает</span> ${timeSavingsText} 
      ${this.mediaMd.matches ? '<span>В денежном</span> <span>эквиваленте это:' : '<span>В денежном эквиваленте это:'}`;
    },
    lengthEconomyMoneyStr() {
      return this.perYear(this.totalEconomy.money, true).trim().length;
    },
  },
  methods: {
    unLockScroll() {
      document.body.classList.remove('no-scroll');
      document.documentElement.style.removeProperty('--scrollbar-width');
    },
    setFontSize(target, baseFontSize) {
      if (this.lengthEconomyMoneyStr <= 7 || !target) return;

      const screenWidth = window.innerWidth;
      const characterCount = target.innerText.length;
      let fontSize = Math.min(baseFontSize, screenWidth / (characterCount / 2));

      if (fontSize < 18) fontSize = 18;

      target.style.fontSize = `${fontSize}px`;
    },
    setFontSizeOnBannerTextAndTitle() {
      this.setFontSize(this.$refs.bannerTitle, 220);
      this.setFontSize(this.$refs.bannerText, 36);
    },
    scrollButtonAnimation() {
      this.$nextTick(() => {
        scrollAnimationProgress(this.$refs.scrollBtn, {
          getStart() {
            return 0;
          },
          getEnd(el, start) {
            return start + 10;
          },
          onProgress: (progress) => {
            this.isScrollBtnHidden = progress >= 0.99;
          },
        });
      });
    },
    scrollToSlider() {
      this.$emit('scrollToSlider');
    },
    splitText(str) {
      const splitStr = str.split('');
      const wrapedStr = splitStr
        .map((item) => {
          return item.trim() !== '' ? `<span class="number">${item}</span>` : `<span>${item}</span>`;
        })
        .join('');

      return wrapedStr;
    },
    perYear(n, shouldFormat = false) {
      const result = Math.ceil(n * 12);
      if (shouldFormat) {
        return numFormat.format(result);
      }
      return result;
    },
    bannerAnimation() {
      const animationEasing = 'cubicBezier(.25,.1,.25,1)';
      this.$nextTick(() => {
        scrollTo(0, { duration: 10 });

        anime({
          targets: this.$refs.bannerText.querySelectorAll('span'),
          opacity: 1,
          translateY: [20, 0],
          delay: anime.stagger(200),
          easing: animationEasing,
          duration: 1000,
        });
        anime({
          targets: this.$refs.bannerText,
          delay: 1500,
          scale: [this.mediaMd.matches ? 1.1 : 1.2, 1],
          translateY: [`${this.mediaSm.matches ? '72%' : '150%'}`, '0%'],
          easing: animationEasing,
          duration: 600,
        });
        anime({
          targets: this.$refs.bannerTitle.querySelectorAll('span'),
          opacity: [0, 1],
          translateY: ['100%', '0%'],
          delay: anime.stagger(70, { start: this.mediaSm.matches ? 1600 : 1500 }),
          easing: 'easeOutQuad',
          duration: 250,
        });
        anime({
          targets: this.$refs.bannerWrapperTitle,
          scale: [0, 1],
          easing: animationEasing,
          delay: 1300,
          duration: 1000,
        });
        anime({
          targets: this.$refs.bannerWrapperButton,
          opacity: [0, 1],
          translateY: [50, 0],
          easing: animationEasing,
          delay: 1800,
          duration: 600,
        });
        anime({
          targets: this.$refs.bannerScrollBtnWrapper,
          opacity: [0, 1],
          easing: animationEasing,
          delay: 2000,
          duration: 600,
          complete: () => {
            this.unLockScroll();
          },
        });
      });
    },
  },
  mounted() {
    this.setFontSizeOnBannerTextAndTitle();
    this.bannerAnimation();
    this.scrollButtonAnimation();

    window.addEventListener('resize', () => {
      this.setFontSizeOnBannerTextAndTitle();
    });
  },
};
</script>

<style lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.banner {
  position: relative;
  display: flex;
  // Fallback
  height: calc(100vh - vars.$headerHeightCompact);
  // Fallback
  height: calc(100svh - vars.$headerHeightCompact);
  align-items: center;
  justify-content: center;
  text-align: center;

  @include mixins.media(md) {
    height: calc(100vh - vars.$headerHeightCompact);
  }

  @include mixins.media(xl) {
    height: calc(100vh - vars.$headerHeightBase);
  }

  .container {
    max-width: 100%;

    @include mixins.media(md) {
      margin-top: -70px;
    }
  }

  &__text {
    @include mixins.font(1.9rem, 1.4);

    display: inline-block;
    letter-spacing: -0.16px;
    transform: scale(1.2) translateY(150%);
    max-width: 33rem;
    margin-bottom: 1.6rem;

    @include mixins.media(md) {
      @include mixins.font(3.4rem, 1.35);

      max-width: 100%;
      font-weight: vars.$fontWeightMedium;
      letter-spacing: -0.54px;
      margin: 0 auto 1.6rem;
    }

    @include mixins.media(lg) {
      @include mixins.font(3.6rem, 1.35);
    }

    br {
      @include mixins.media(sm, max) {
        display: none;
      }
    }

    span {
      opacity: 0;
      display: inline-block;
    }

    &-days {
      color: #6865d4;
    }
  }

  &__wrapper-title {
    overflow: hidden;
    transform: scale(0);
    transform-origin: bottom;
  }

  &__title {
    @include mixins.font(6rem, 1.1);

    display: inline;
    position: relative;
    margin-right: -1.2rem;
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: vars.$fontWeightMedium;
    letter-spacing: -0.9px;
    letter-spacing: -2px;
    white-space: nowrap;

    @include mixins.media(md) {
      @include mixins.font(14.4rem, 1.1);

      margin-right: initial;
      letter-spacing: -2.16px;
      transform: translateX(-35px);
    }

    @include mixins.media(lg) {
      @include mixins.font(17.6rem, 1.1);

      letter-spacing: -2.64px;
      transform: initial;
    }

    @include mixins.media(xl) {
      @include mixins.font(20rem, 1.1);

      letter-spacing: -4px;
    }

    span {
      display: inline-block;
      transform: translateY(100%);
    }
  }

  &__year {
    @include mixins.font(1.4rem, 1.5);

    display: inline-block;
    white-space: nowrap;
    letter-spacing: initial;

    @include mixins.media(md) {
      @include mixins.font(3rem, 1.35);

      letter-spacing: -0.45px;
    }
  }

  &__wrapper-button {
    opacity: 0;
  }

  &__button {
    padding: 1.6rem 2.4rem;
    margin-top: 2.4rem;
    @include mixins.media(md) {
      @include mixins.font(2.4rem);

      padding: 2.4rem 5.6rem;
      margin-top: 4rem;
    }
  }

  &__links {
    margin-top: 2.4rem;

    @include mixins.media(sm, max) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    @include mixins.media(md) {
      margin-top: 1.6rem;
    }
  }

  &__link {
    @include mixins.font(1.4rem, 1.42);

    position: relative;
    display: inline-block;
    padding-left: 2.4rem;
    margin-bottom: 1.2rem;
    color: #000;
    font-weight: vars.$fontWeightBase;
    opacity: 0.3;
    transition: opacity vars.$transitionDurationBase;

    @include mixins.media(md) {
      @include mixins.font(1.6rem, 1.55);

      margin: 0 8px;
    }

    &:hover {
      transition: opacity vars.$transitionDurationBase;
      opacity: 1;
    }

    &::after {
      @include mixins.size(1.8rem);

      position: absolute;
      left: 0;
      content: '';
      background-repeat: no-repeat;

      @include mixins.media(md) {
        top: 2.5px;
      }
    }

    &:nth-child(1) {
      &::after {
        background-image: url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_1479_599)'%3E%3Cpath d='M8.25 2.95728H3C2.60218 2.95728 2.22064 3.11531 1.93934 3.39662C1.65804 3.67792 1.5 4.05945 1.5 4.45728V14.9573C1.5 15.3551 1.65804 15.7366 1.93934 16.0179C2.22064 16.2992 2.60218 16.4573 3 16.4573H13.5C13.8978 16.4573 14.2794 16.2992 14.5607 16.0179C14.842 15.7366 15 15.3551 15 14.9573V9.70728' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.875 1.82952C14.1734 1.53115 14.578 1.36353 15 1.36353C15.422 1.36353 15.8266 1.53115 16.125 1.82952C16.4234 2.12788 16.591 2.53256 16.591 2.95452C16.591 3.37647 16.4234 3.78115 16.125 4.07952L9 11.2045L6 11.9545L6.75 8.95452L13.875 1.82952Z' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1479_599'%3E%3Crect width='18' height='18' fill='white' transform='translate(0 0.5)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
      }
    }

    &:nth-child(2) {
      &::after {
        background-image: url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_1479_604)'%3E%3Cpath d='M9 16.5002C13.1421 16.5002 16.5 13.1424 16.5 9.00024C16.5 4.85811 13.1421 1.50024 9 1.50024C4.85786 1.50024 1.5 4.85811 1.5 9.00024C1.5 13.1424 4.85786 16.5002 9 16.5002Z' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M6.8125 6.74969C6.98883 6.24845 7.33686 5.82577 7.79497 5.55654C8.25307 5.28731 8.79167 5.1889 9.31538 5.27873C9.83909 5.36856 10.3141 5.64084 10.6563 6.04734C10.9985 6.45384 11.1858 6.96834 11.185 7.49969C11.185 8.99969 8.935 9.74969 8.935 9.74969' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M9 12.7502H9.00667' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1479_604'%3E%3Crect width='18' height='18' fill='white' transform='translate(0 0.5)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
      }
    }
  }

  &__scroll-btn {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 1.4rem 0;
    cursor: pointer;
    transition: color vars.$transitionDurationBase;
    color: #c6c6c6;

    @include mixins.media(md) {
      @include mixins.font(3rem, 1.27, -0.45px);

      padding: 2rem 0;
      font-weight: vars.$fontWeightMedium;
      transition: color vars.$transitionDurationBase;

      @media (max-height: 650px) {
        display: none;
      }
    }

    span {
      display: flex;
      align-items: center;
      transform: translateX(10px);

      @include mixins.media(sm, max) {
        max-width: 230px;
        line-height: 1.2;
      }
    }

    svg {
      flex-shrink: 0;
      margin-left: 0.8rem;
      opacity: calc(1 - (1 * #{vars.$progress}));

      @include mixins.media(sm, max) {
        @include mixins.size(1.8rem);

        transform: translate(-42px, 10px);
      }

      @include mixins.media(md) {
        margin-left: 1rem;
        transform: translateY(4px);
      }

      path {
        transition: vars.$transitionDurationBase;

        @include mixins.media(sm, max) {
          stroke-width: 3;
        }
      }
    }

    &--disabled {
      pointer-events: none;
    }

    &:hover {
      color: vars.$colorBase;
      transition: vars.$transitionDurationBase;

      path {
        transition: vars.$transitionDurationBase;
        stroke: vars.$colorBase;
      }
    }
  }
}
</style>
